import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative z-10 p-4" }
const _hoisted_2 = { class: "bg-background border-primary" }
const _hoisted_3 = { class: "max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4" }
const _hoisted_4 = {
  href: "https://flowbite.com/",
  class: "flex items-center space-x-3 rtl:space-x-reverse"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo.png",
  class: "h-20",
  alt: "{{ $t('brand.name') }}"
}, null, -1)
const _hoisted_6 = { class: "self-center text-2xl font-semibold whitespace-nowrap text-text" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  "data-collapse-toggle": "navbar-default",
  type: "button",
  class: "inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-text-light rounded-lg md:hidden hover:bg-accentExtra-lightest focus:outline-none focus:ring-2 focus:ring-primary"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu"),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 14"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M1 1h15M1 7h15M1 13h15"
    })
  ])
], -1)
const _hoisted_8 = {
  class: "hidden w-full md:block md:w-auto",
  id: "navbar-default"
}
const _hoisted_9 = { class: "font-medium flex flex-col p-4 md:p-0 mt-4 border border-primary rounded-lg bg-background md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "antialiased" }
const _hoisted_14 = { class: "text-text body-font" }
const _hoisted_15 = { class: "container mx-auto flex md:px-24 md:py-10 md:flex-row flex-col items-center" }
const _hoisted_16 = { class: "lg:flex-grow mt-5 md:mt-0 md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start ltr:md:text-left rtl:md:text-right mb-16 md:mb-0 items-center text-center" }
const _hoisted_17 = { class: "text-2xl font-extrabold leading-9 tracking-tight mb-3 text-text sm:text-4xl sm:leading-10 md:text-5xl md:leading-normal" }
const _hoisted_18 = { class: "mb-8 ltr:md:pl-0 rtl:md:pr-0 pl-2 pr-2 leading-relaxed text-text-light" }
const _hoisted_19 = { class: "flex justify-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "lg:max-w-lg lg:w-full mb-5 md:mb-0 md:w-1/2 w-3/6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "object-cover object-center rounded",
    alt: "{{ $t('brand.name') }}",
    src: "/images/homepage/hero_section.png"
  })
], -1)
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-xl",
  src: "/images/homepage/story_query.png",
  alt: "Create new Story"
}, null, -1)
const _hoisted_24 = { class: "mt-4 md:mt-0" }
const _hoisted_25 = { class: "mb-4 text-4xl tracking-tight font-extrabold text-text" }
const _hoisted_26 = { class: "text-text" }
const _hoisted_27 = { class: "text-2xl font-bold text-blue-800 mb-4 text-center" }
const _hoisted_28 = { class: "text-text-light mb-4" }
const _hoisted_29 = { class: "space-y-2 mb-4" }
const _hoisted_30 = { class: "flex items-center justify-start" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 text-xl" }, "🌟", -1)
const _hoisted_32 = { class: "rtl:mr-2 ltr:ml-2" }
const _hoisted_33 = { class: "flex items-center justify-start" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 text-xl" }, "🌟", -1)
const _hoisted_35 = { class: "rtl:mr-2 ltr:ml-2" }
const _hoisted_36 = { class: "flex items-center justify-start" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 text-xl" }, "🌟", -1)
const _hoisted_38 = { class: "rtl:mr-2 ltr:ml-2" }
const _hoisted_39 = { class: "flex items-center justify-start" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 text-xl" }, "🌟", -1)
const _hoisted_41 = { class: "rtl:mr-2 ltr:ml-2" }
const _hoisted_42 = { class: "mb-4 ltr:text-left rtl:text-right" }
const _hoisted_43 = { class: "ltr:text-left rtl:text-right mb-4" }
const _hoisted_44 = { class: "" }
const _hoisted_45 = { class: "gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6" }
const _hoisted_46 = { class: "mt-4 md:mt-0" }
const _hoisted_47 = { class: "mb-4 text-4xl tracking-tight font-extrabold text-text" }
const _hoisted_48 = { class: "mb-6 font-light text-text-light md:text-lg" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-xl",
  src: "/images/homepage/turn_into_the_future.png",
  alt: "Turn into the future"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    referrerpolicy: "origin",
    target: "_blank",
    href: "https://trustseal.enamad.ir/?id=526444&Code=Vv1pil9MFGQnLMsvnhaeGUzJ1sDi98G7"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      referrerpolicy: "origin",
      src: "https://trustseal.enamad.ir/logo.aspx?id=526444&Code=Vv1pil9MFGQnLMsvnhaeGUzJ1sDi98G7",
      alt: "",
      style: {"cursor":"pointer"},
      code: "Vv1pil9MFGQnLMsvnhaeGUzJ1sDi98G7"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_curved_background = _resolveComponent("curved-background")!

  return (_openBlock(), _createBlock(_component_curved_background, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('brand.name')), 1)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.$t('home.navbar.home.link'),
                    class: "block py-2 px-3 text-text-light bg-secondary rounded md:bg-transparent md:text-secondary-dark md:p-0",
                    "aria-current": "page"
                  }, _toDisplayString(_ctx.$t('home.navbar.home.text')), 9, _hoisted_10)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.$t('home.navbar.aboutUs.link'),
                    class: "block py-2 px-3 text-text rounded hover:bg-accentExtra-lightest md:hover:bg-transparent md:border-0 md:hover:text-accent md:p-0"
                  }, _toDisplayString(_ctx.$t('home.navbar.aboutUs.text')), 9, _hoisted_11)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.$t('home.navbar.contactUs.link'),
                    class: "block py-2 px-3 text-text rounded hover:bg-accentExtra-lightest md:hover:bg-transparent md:border-0 md:hover:text-accent md:p-0"
                  }, _toDisplayString(_ctx.$t('home.navbar.contactUs.text')), 9, _hoisted_12)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("section", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t('brand.slogan')), 1),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('brand.mission')), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: { name: 'TurnFuture' },
                    class: "inline-flex text-text bg-primary border-0 py-2 px-6 focus:outline-none hover:bg-primary-dark rounded text-lg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.letsStart')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_20
            ])
          ]),
          _createElementVNode("section", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t('home.askAnything')), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t('home.smartSearch')), 1),
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('home.smartSearchDescription')), 1),
                  _createElementVNode("ul", _hoisted_29, [
                    _createElementVNode("li", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('home.smartSearchFeatures[0].description')), 1)
                    ]),
                    _createElementVNode("li", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('home.smartSearchFeatures[1].description')), 1)
                    ]),
                    _createElementVNode("li", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('home.smartSearchFeatures[2].description')), 1)
                    ]),
                    _createElementVNode("li", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('home.smartSearchFeatures[3].description')), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('home.smartSearchExamples')), 1),
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('home.smartSearchExperience')), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'createUserStory' },
                  class: "inline-flex items-center text-text bg-primary hover:bg-primary-dark focus:ring-4 focus:ring-primary-light font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('home.trySmartSearch')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("h2", _hoisted_47, _toDisplayString(_ctx.$t('common.turnFuture')), 1),
                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('home.turnFutureDescription')), 1),
                _createVNode(_component_router_link, {
                  to: { name: 'TurnFuture' },
                  class: "inline-flex items-center text-text bg-primary hover:bg-primary-dark focus:ring-4 focus:ring-primary-light font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('home.turnFutureCTA')), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_49
            ])
          ])
        ])
      ]),
      _hoisted_50
    ]),
    _: 1
  }))
}